import { useSyncExternalStore } from 'react';

// prefers-reduced-motion, followed live (turning it on mid-session stills the
// next render). Without matchMedia (tests, an old engine) motion stays on.
const QUERY = '(prefers-reduced-motion: reduce)';

function mql(): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(QUERY) : null;
}

function subscribe(listener: () => void): () => void {
  const m = mql();
  if (!m || typeof m.addEventListener !== 'function') return () => undefined;
  m.addEventListener('change', listener);
  return () => m.removeEventListener('change', listener);
}

export function prefersReducedMotion(): boolean {
  return mql()?.matches ?? false;
}

export function useReducedMotion(): boolean {
  return useSyncExternalStore(subscribe, prefersReducedMotion, () => false);
}
